import { createApp, h } from "vue";
import Builder from "./components/Builder";

const app = createApp({
    render: () => h(Builder),
});

app.mount("#invoice-builder");
